import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export enum IRecurrentFrequencyOptions {
	NoRepeat = 'no-repeat',
	Daily = 'daily',
	WeekDaily = 'weekdaily',
	Weekly = 'weekly',
	Biweekly = 'biweekly',
	Monthly = 'monthly',
	Custom = 'custom',
}

@Component({
	selector: 'frequency-select',
	templateUrl: './frequency-select.component.html',
})
export class FrequencySelectComponent implements OnInit {
	@Output() onSelectOption = new EventEmitter();
	options = [];
	public _value: IRecurrentFrequencyOptions;
	private onChange: (value: IRecurrentFrequencyOptions) => void = () => {};
	private onTouched: () => void = () => {};

	@Input() value: IRecurrentFrequencyOptions;
	@Input() action: 'create' | 'edit' = 'create';
	constructor() {}

	ngOnInit(): void {
		this.options = [
			{ value: 'Não se repete', id: IRecurrentFrequencyOptions.NoRepeat },
			{ value: 'Todos os dias', id: IRecurrentFrequencyOptions.Daily },
			{
				value: 'Todos os dias da semana',
				id: IRecurrentFrequencyOptions.WeekDaily,
			},
			{ value: 'Semanalmente', id: IRecurrentFrequencyOptions.Weekly },
			{ value: 'Cada duas semanas', id: IRecurrentFrequencyOptions.Biweekly },
			{ value: 'Mensal', id: IRecurrentFrequencyOptions.Monthly },
		];
		setTimeout(() => {
			this._value = this.value;
		}, 500);
	}

	selectOption(event: IRecurrentFrequencyOptions) {
		this.onChange(event);
		this.onTouched();
		this.onSelectOption.emit(event);
	}
}
